import Vue from 'vue'

// 引入组件
import { Picker, DatetimePicker, Dialog, NavBar, Image, Field, Button , SwipeCell, Uploader, Overlay, Icon, Stepper, Popup, Area, cell, Tab, Tabs, Search, Swipe, SwipeItem, Toast,Checkbox, CheckboxGroup, Loading, Skeleton, Tag, Divider, Sku, RadioGroup, Radio  } from 'vant'
import { Result } from 'vant-green';
// 使用组件
Vue.use(Popup).use(Area).use(cell).use(Tab).use(Tabs).use(Search).use(Swipe).use(SwipeItem).use(Toast).use(Checkbox).use(CheckboxGroup)
.use(Loading).use(Skeleton).use(Tag).use(Divider).use(Sku).use(Radio).use(RadioGroup).use(Stepper).use(Icon).use(Overlay).use(Uploader)
.use(SwipeCell).use(Button).use(Image).use(Field).use(NavBar).use(Dialog).use(DatetimePicker).use(Picker).use(Result);